<template>
    <el-dialog title="选择回传方案" :visible.sync="innerVisible" class="dialog-table" width="800px"
        :before-close="closeDialogTable">
        <div v-if="platform == 'wx-sv' || platform == 'wx-gg-sv' " class="return-platform">
            <span>回传平台</span>
            <el-radio-group v-model="returnPlatform" @input="handleReturnPlatform" class="item">
                <el-radio :label="1" v-if="platform != 'wx-sv' && platform != 'wx-gg-sv'">巨量回传</el-radio>
                <el-radio :label="2" v-else>腾讯广点通回传</el-radio>
            </el-radio-group>
        </div>
        <el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline">
            <el-form-item label="方案名" prop="title">
                <el-input type="text" v-model="formInline.title" placeholder="请输入方案名" clearable
                    @keyup.enter.native="search" @clear="search" style="width: 180px;"></el-input>
            </el-form-item>
            <el-form-item label="回传类型" prop="type" style="margin-right: 30px;">
                <!-- clearable  :disabled="typeVal !== item.value"-->
                <el-select v-model="formInline.type" placeholder="请选择回传类型" @change="search" style="width: 180px;">
                    <el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="tableTh">
            <!-- 巨量-免费回传列表 -->
            <el-table :data="tableData.result" ref="singleTable" border highlight-current-row
                @current-change="handleCurrentChangeTable" height="500" row-key="id" style="width: 100%;"
                class="tableStyle table-radio" v-if="returnPlatform == 1">
                <el-table-column align="center" width="55" label>
                    <template slot-scope="scope">
                        <!--<el-radio @change.native="handleCurrentChangeTable(scope.row)" v-model="selected" :label="scope.row.id">&nbsp;</el-radio>-->
                        <el-checkbox @change.native="handleCurrentChangeTable(scope.row)" v-model="selected"
                            :label="scope.row.id"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="方案名" width="130">
                </el-table-column>

                <el-table-column label="回传类型" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == 1">免费回传</span>
                        <span v-if="scope.row.type == 2">付费回传</span>
                    </template>
                </el-table-column>
                <el-table-column label="回传状态" width="100" v-if="formInline.type == 1">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1">广告回传</span>
                        <span v-if="scope.row.status == 2">按人回传</span>
                    </template>
                </el-table-column>
                <el-table-column label="回传方式" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.way == 1">关键行为</span>
                        <span v-if="scope.row.way == 2">付费</span>
                    </template>
                </el-table-column>
                <el-table-column label="回传配置" width="130" v-if="formInline.type == 2">
                    <template slot-scope="scope">
                        <span v-if="scope.row.postbakSet == 1">全部回传配置</span>
                        <span v-if="scope.row.postbakSet == 2">自定义回传配置</span>
                    </template>
                </el-table-column>
                <el-table-column label="回传条件" v-if="formInline.type == 1">
                    <template slot-scope="scope">
                        <div class="td-info">
                            <p>条件：</p>
                            <p>广告播放≥{{ scope.row.adNumber }}</p>
                            <p>
                                <span v-if="scope.row.relation == 1">且</span>
                                <span v-if="scope.row.relation == 2">或</span>
                            </p>
                            <p>
                                <span v-if="scope.row.ecpmType == 1">ECPM≥{{ scope.row.ecpmNumber }}</span>
                                <span v-if="scope.row.ecpmType == 2">ECPM≤{{ scope.row.ecpmNumber }}</span>
                                <span v-if="scope.row.ecpmType == 3">{{ scope.row.ecpmNumber }}≤ECPM≤{{
                                    scope.row.ecpmAfterNumber }}</span>
                            </p>
                            <P>
                                <span v-if="scope.row.arpuType == 1">ARPU≥{{ scope.row.arpuNumber }}</span>
                                <span v-if="scope.row.arpuType == 2">ARPU≤{{ scope.row.arpuNumber }}</span>
                                <span v-if="scope.row.arpuType == 3">{{ scope.row.arpuNumber }}≤ARPU≤{{
                                    scope.row.arpuAfterNumber }}</span>
                            </P>
                            <p>回传设置：</p>
                            <p>
                                <span style="margin-right: 10px;">{{ scope.row.postbakSet == 2 ? '自定义回传' :
                                    '全部回传' }}</span>
                                <span v-if="scope.row.postbakSet == 2">传{{ scope.row.conveyNumber }}漏{{
                                    scope.row.omitNumber }}</span>
                            </p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="回传规则" v-if="formInline.type == 2">
                    <template slot-scope="scope">
                        <div class="td-info">
                            <p v-if="scope.row.postbakSet == 1">
                                <span v-if="scope.row.payBackWay == 1">回传用户所有充值</span>
                                <span v-if="scope.row.payBackWay == 2">回传用户当天自然日所有充值</span>
                                <span v-if="scope.row.payBackWay == 3">回传用户24小时内所有充值</span>
                                <span v-if="scope.row.payBackWay == 4">回传用户首充</span>
                                <span v-if="scope.row.payBackWay == 5">回传用户当天自然日首充</span>
                                <span v-if="scope.row.payBackWay == 6">回传用户24小时内首充</span>
                                <span v-if="scope.row.payBackWay == 7">回传用户在X小时内首次充值金额大于Y后的所有充值（含首次充值）</span>
                                <span v-if="scope.row.payBackWay == 8">回传用户在X小时内单笔充值金额大于Y的首充</span>
                            </p>
                            <div v-if="scope.row.postbakSet == 2">
                                <p>回传维度：
                                    <span v-if="scope.row.havePlan == 0">按链接回传</span>
                                    <span v-if="scope.row.havePlan == 1">按计划回传</span>
                                </p>
                                <p>回传保护数：
                                    <span>{{ scope.row.havePlanNumber }}</span>
                                </p>
                                <p>回传时间：
                                    <span v-if="scope.row.havePlanTime == 1">开启</span>
                                    <span v-if="scope.row.havePlanTime == 0">关闭</span>
                                </p>
                            </div>
                        </div>
                    </template>
                </el-table-column>

                <!-- <el-table-column prop="strAddTime" label="回传类型" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == 1">免费回传</span>
                    </template>
                </el-table-column>
                <el-table-column label="回传状态" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1">广告回传</span>
                        <span v-if="scope.row.status == 2">按人回传</span>
                    </template>
                </el-table-column>
                <el-table-column prop="strAddTime" label="回传方式" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.way == 1">关键行为</span>
                    </template>
                </el-table-column>
                <el-table-column label="回传条件">
                    <template slot-scope="scope">
                        <div class="td-info">
                            <p>条件：</p>
                            <p>广告播放≥{{scope.row.adNumber}}</p>
                            <p>
                                <span v-if="scope.row.relation == 1">且</span>
                                <span v-if="scope.row.relation == 2">或</span>
                            </p>
                            <p>
                                <span v-if="scope.row.ecpmType == 1">ECPM≥{{scope.row.ecpmNumber}}</span>
                                <span v-if="scope.row.ecpmType == 2">ECPM≤{{scope.row.ecpmNumber}}</span>
                                <span v-if="scope.row.ecpmType == 3">{{scope.row.ecpmNumber}}≤ECPM≤{{scope.row.ecpmAfterNumber}}</span>
                            </p>
                            <P>
                                <span v-if="scope.row.arpuType == 1">ARPU≥{{scope.row.arpuNumber}}</span>
                                <span v-if="scope.row.arpuType == 2">ARPU≤{{scope.row.arpuNumber}}</span>
                                <span v-if="scope.row.arpuType == 3">{{scope.row.arpuNumber}}≤ARPU≤{{scope.row.arpuAfterNumber}}</span>
                            </P>
                            <p>回传设置：</p>
                            <p>
                                <span style="margin-right: 10px;">{{scope.row.postbakSet == 2 ? '自定义回传' : '全部回传'}}</span>
                                <span v-if="scope.row.postbakSet == 2">传{{scope.row.conveyNumber}}漏{{scope.row.omitNumber}}</span>
                            </p>
                        </div>
                    </template>
                </el-table-column> -->
            </el-table>
            <!-- 腾讯-回传列表 -->
            <el-table :data="tableData.result" ref="singleTable" border highlight-current-row
                @current-change="handleCurrentChangeTable" height="500" row-key="id" style="width: 100%;"
                class="tableStyle table-radio" v-if="returnPlatform == 2">
                <el-table-column align="center" width="55" label>
                    <template slot-scope="scope">
                        <!--<el-radio @change.native="handleCurrentChangeTable(scope.row)" v-model="selected" :label="scope.row.id">&nbsp;</el-radio>-->
                        <el-checkbox @change.native="handleCurrentChangeTable(scope.row)" v-model="selected"
                            :label="scope.row.id"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="方案名">
                </el-table-column>
                <el-table-column label="回传类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == 1">免费回传</span>
                        <span v-if="scope.row.type == 4">付费回传</span>
                    </template>
                </el-table-column>
                <el-table-column label="投放目标" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.way == 1">关键行为</span>
                        <span v-if="scope.row.way == 2">付费</span>
                        <span v-if="scope.row.way == 3">注册</span>
                    </template>
                </el-table-column>
                <el-table-column label="回传条件" v-if="formInline.type == 3">
                    <template slot-scope="scope">
                        <div class="td-info">
                            <p>条件一：</p>
                            <p>点击时长≥{{ scope.row.conditionTime }}秒</p>
                            <p>
                                <span v-if="scope.row.firstCondition == 1">且</span>
                                <span v-if="scope.row.firstCondition == 2">或</span>
                            </p>
                            <p>条件二：</p>
                            <p>
                                广告播放次数≥{{ scope.row.adPlay }}次&nbsp;&nbsp;
                                <span v-if="scope.row.secondCondition == 1">且</span>
                                <span v-if="scope.row.secondCondition == 2">或</span>&nbsp;&nbsp;
                                浏览集数≥{{ scope.row.adPlay }}集
                            </p>
                            <p>回传设置：</p>
                            <p>
                                <span style="margin-right: 10px;">{{ scope.row.postbakSet == 2 ? '自定义回传' : '全部回传'
                                    }}</span>
                                <span v-if="scope.row.postbakSet == 2">传{{ scope.row.conveyNumber }}漏{{
                                    scope.row.omitNumber }}</span>
                            </p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="回传配置" width="130" v-if="formInline.type == 4">
                    <template slot-scope="scope">
                        <span v-if="scope.row.postbakSet == 1">全部回传配置</span>
                        <span v-if="scope.row.postbakSet == 2">自定义回传配置</span>
                    </template>
                </el-table-column>
                <el-table-column label="回传规则" v-if="formInline.type == 4">
                    <template slot-scope="scope">
                        <div class="td-info">
                            <p v-if="scope.row.postbakSet == 1">
                                <span v-if="scope.row.payBackWay == 1">回传用户所有充值</span>
                                <span v-if="scope.row.payBackWay == 2">回传用户当天自然日所有充值</span>
                                <span v-if="scope.row.payBackWay == 3">回传用户24小时内所有充值</span>
                                <span v-if="scope.row.payBackWay == 4">回传用户首充</span>
                                <span v-if="scope.row.payBackWay == 5">回传用户当天自然日首充</span>
                                <span v-if="scope.row.payBackWay == 6">回传用户24小时内首充</span>
                                <span v-if="scope.row.payBackWay == 7">回传用户在X小时内首次充值金额大于Y后的所有充值（含首次充值）</span>
                                <span v-if="scope.row.payBackWay == 8">回传用户在X小时内单笔充值金额大于Y的首充</span>
                            </p>
                            <div v-if="scope.row.postbakSet == 2">
                                <p>回传维度：
                                    <span v-if="scope.row.havePlan == 0">按链接回传</span>
                                    <span v-if="scope.row.havePlan == 1">按计划回传</span>
                                </p>
                                <p>回传保护数：
                                    <span>{{ scope.row.havePlanNumber }}</span>
                                </p>
                                <p>回传时间：
                                    <span v-if="scope.row.havePlanTime == 1">开启</span>
                                    <span v-if="scope.row.havePlanTime == 0">关闭</span>
                                </p>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="foot-table" style="text-align:center;">
                <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
                    :page-sizes="[5, 20, 50, 100, 200, 500]" :page-size="tableData.pageSize" background
                    :current-page="currentPage" layout="sizes, prev, pager, next, jumper, ->, total"
                    :total="tableData.totalNum">
                </el-pagination>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialogTable">取 消</el-button>
            <el-button type="primary" @click="tableSureBtn">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { list } from "@/api/dysvzk/agentmenu/return";
export default {
    name: 'ReturnTable',
    // props: {
    //     visible: {
    //         type: Boolean,
    //         required: true
    //     },
    //     selectReturn: {
    //         type: Object,
    //         required: true
    //     },
    //     postbackId: Number
    // },
    props: ['visible', 'selectReturn', 'svId', 'priceFlag', 'postbackId', 'posterId', 'rechargeId','postbackType'],
    data() {
        return {
            innerVisible: this.visible,
            selected: [],
            formInline: {
                title: '',
                type: 1
            },
            typeOptions: [
                {
                    value: 1,
                    label: '免费回传',
                },
                {
                    value: 2,
                    label: '付费回传',
                },
            ],
            tableData: [],
            currentPage: 1,
            pageSize: 5,
            currentRow: '',
            typeVal: '',
            platform: localStorage.getItem('platform'),
            returnPlatform: 1,//回传平台
        }
    },
    watch: {
        visible(newValue) {
            this.innerVisible = newValue;
            this.pr
            this.$nextTick(() => {
                this.$refs.singleTable.setCurrentRow(this.selectReturn)
                if(this.platform == 'wx-sv' || this.platform == 'wx-gg-sv'){
                    this.returnPlatform = 2
                    this.typeOptions = [
                        {
                            value: 3,
                            label: '免费回传',
                        },
                        {
                            value: 4,
                            label: '付费回传',
                        },
                    ]
                    // if(this.postbackType == 3){

                    // }
                }else{
                    this.returnPlatform = 1
                    this.typeOptions = [
                        {
                            value: 1,
                            label: '免费回传',
                        },
                        {
                            value: 2,
                            label: '付费回传',
                        },
                    ]
                }
                if (this.platform == 'dy-dp') {
                    this.formInline.type = this.priceFlag == 1 ? 1 : 2
                } else {
                    this.formInline.type = this.postbackType
                }
                // if ( (this.platform == 'wx-sv' && this.returnPlatform == 1) || (this.platform == 'wx-gg-sv' && this.returnPlatform == 1) ) {
                //     this.formInline.type = 2
                //     this.typeOptions = [
                //         {
                //             value: 2,
                //             label: '付费回传'
                //         },
                //     ]
                // } else if (this.platform == 'dy-dp') {
                //     this.formInline.type = this.priceFlag == 1 ? 1 : 2
                // }

                console.log("postbackType",this.postbackType)

                this.getTableData()
                // if(this.posterId){
                //     this.typeVal = 1
                //     this.formInline.type == 1
                // }
                // if(this.rechargeId){
                //     this.typeVal = 2
                //     this.formInline.type == 2
                // }
                // if (this.postbackId) {
                //     console.log(this.postbackId)
                //     const row = this.tableData.result.find(row => row.id === this.postbackId);
                //     this.$refs.singleTable.setCurrentRow(row);
                // } else {
                //     this.$refs.singleTable.setCurrentRow(this.selectReturn)
                // }
            })
        },
        svId(newValue) {
            this.svId = newValue
            this.getTableData()
        },
        innerVisible(newValue) {
            this.$emit('update:visible', newValue);
        }
    },
    mounted() {
        
    },
    methods: {
        // 选择回传平台
        handleReturnPlatform(val) {
            console.log("选择回传平台", this.returnPlatform,val)
            if ( (this.platform == 'wx-sv' && val == 2) || (this.platform == 'wx-gg-sv' && val == 2)) {
                this.formInline.type = 3
                this.typeOptions = [
                    {
                        value: 3,
                        label: '免费回传'
                    },
                    {
                        value: 4,
                        label: '付费回传'
                    },
                ]
            } else {
                this.formInline.type = 2
                this.typeOptions = [
                    {
                        value: 2,
                        label: '付费回传'
                    },
                ]
            }
            this.getTableData()
        },
        search () {
            this.currentPage = 1
            this.getTableData()
        },
        resetQuery: function () {
            this.$refs['formInline'].resetFields()
            this.getTableData()
        },
        // 分页
        handleCurrentChange(value) {
            this.currentPage = value
            this.getTableData()
        },
        // pageSize切换
        handleSizeChange(val) {
            this.pageSize = val
            this.currentPage = 1
            this.getTableData()
        },
        // 单选
        handleCurrentChangeTable(val) {
            console.log(val)
            this.$refs.singleTable.setCurrentRow(val);
            this.currentRow = {...val,postType:this.formInline.type}
            this.selected = [val.id]
            console.log(this.selected)
        },
        // 确定按钮
        tableSureBtn() {
            this.$emit('returnSure', this.currentRow,this.returnPlatform);
            this.$emit('cancelDialogReturn', false);
            // this.closeDialogTable()
            // this.$refs.singleTable.setCurrentRow();
        },
        // 关闭弹框
        closeDialogTable() {
            console.log('关闭弹框')
            this.$emit('cancelDialogReturn', false);
            // this.$refs.singleTable.setCurrentRow();
            // this.selected = []
        },
        getTableData() {
            if ( (this.platform == 'wx-sv' && this.returnPlatform == 2) || (this.platform == 'wx-gg-sv' && this.returnPlatform == 2)) {
                let json2 = {
                    appId: this.appId,
                    pageNo: this.currentPage,
                    pageSize: this.pageSize
                };
                let json1 = {
                    ...this.formInline,
                    type:this.formInline.type 
                };
                let paramJson = { ...json1, ...json2 };
                if(this.formInline.type == 4){
                    list(paramJson).then(response => {
                        if (response.data.head.flag === 0) {
                            this.tableData = response.data.content
                        } else {
                            this.$message.error(response.data.head.desc)
                        }
                    });
                }else{
                    this.axios({
                        method: 'get',
                        url: '/video/VideoPostbackTxTx/getList',
                        params: paramJson
                    }).then((response) => {
                        if (response.data.head.flag === 0) {
                            this.tableData = response.data.content
                            // this.loading = false
                        } else {
                            this.$message.error(response.data.head.desc)
                        }
                    })
                }
                
            } else {
                let json2 = {
                    appId: this.appId,
                    pageNo: this.currentPage,
                    pageSize: this.pageSize
                };
                let json1 = {
                    ...this.formInline,
                };
                let paramJson = { ...json1, ...json2 };
                console.log("-回传--",this.formInline)
                list(paramJson).then(response => {
                    if (response.data.head.flag === 0) {
                        this.tableData = response.data.content
                    } else {
                        this.$message.error(response.data.head.desc)
                    }
                });
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.return-platform {
    margin-bottom: 30px;

    .item {
        margin-left: 30px;
    }
}
</style>
